// Vorschau der Wallpaper-Seite: Einzel mit chessground wie bisher, alle anderen Modi als Szene.
import { h, type VNode } from 'snabbdom';
import type { GameDetail, LessonPly, WallpaperSettings } from '../api';
import { board, plyConfig } from '../board';
import { appPieces } from '../util';
import { t } from '../i18n';
import { scenePreview } from './wpscene';
import { learnPreview } from './wplearn';

const ANIM_MS = { none: 0, fast: 120, normal: 250, slow: 500 } as const;

export function previewView(s: WallpaperSettings, games: GameDetail[], ply: number, ticks: number, lesson: LessonPly[]): VNode {
  if (!games.length) return h('div.desk.empty', h('p.muted', t('Wähle in der Bibliothek Partien für das Wallpaper aus.')));
  if (s.mode === 'learn') return learnPreview(s, games[0], lesson, ply, appPieces());
  return s.mode === 'single' ? singlePreview(s, games[0], ply) : scenePreview(s, games, ticks, appPieces());
}

function singlePreview(s: WallpaperSettings, p: GameDetail | null, at: number): VNode {
  if (!p) return h('div.desk.empty');
  const ply = p.plies[Math.min(at, p.plies.length - 1)];
  const g = p.game;
  const san = ply.san ? `${Math.ceil(at / 2)}${at % 2 ? '.' : '…'} ${ply.san}` : '';
  return h(`div.desk.set-${appPieces()}`, { style: { '--bs': `${s.boardSize * 100}cqh`, '--dim': String(s.brightness) } as any }, [
    h(`div.stage.${s.position}`, [
      // wie auf lichess: Schwarz über dem Brett, Weiß darunter
      s.showNames ? h('div.caption.top', h('div.pl', g.black ?? '?')) : null,
      h(`div.wpboard.theme-${s.theme}`, { class: { nolast: !s.showLastMove } }, [
        board('wp-preview', {
          ...plyConfig(ply),
          viewOnly: true,
          coordinates: s.showCoordinates,
          animation: { enabled: ANIM_MS[s.animation] > 0, duration: ANIM_MS[s.animation] },
          drawable: { enabled: false, visible: false },
        }),
      ]),
      h('div.caption', [
        s.showNames ? h('div.pl', g.white ?? '?') : null,
        // Jahr nur, wenn es in der PGN steht
        s.showYear && g.year ? h('div.yr', String(g.year)) : null,
        s.showMove && san ? h('div.mv', san) : null,
      ]),
    ]),
  ]);
}
